// import hooks
import { useTranslation } from "react-i18next";

// import components
import RoutPath from "./RoutPath";
import { Container, Row, Col } from "react-bootstrap";
import CardStyle1 from "./Main/CardStyle1";

// import assets
import "../assets/css/cards.css";

// import data
import cardListData from "../utils/data/cardListData";

// props
//{props.h}
//props.products
const ProductsPage = () => {
    const [t] = useTranslation("global");
    return (
        <section className="products-page-section ocean-section">
            <Container>
                <RoutPath />
                <h1 className="ocean-h1 products-page-head">نتائج البحث</h1>
                <div className="products-list-div">
                    <Row>
                        {cardListData[0].items.map((i) => (
                            <Col lg={3} md={4} key={i.id} className="mb-4">
                                <CardStyle1 item={i} />
                            </Col>
                        ))}
                    </Row>
                    <Row className="flex-center-row">
                        <button className="ocean-btn view-more-btn mb-4">
                            {t("products.view-more")}
                        </button>
                    </Row>
                </div>
            </Container>
        </section>
    );
};

export default ProductsPage;
